module.exports = __webpack_public_path__ + "24626ae729603e9ac5626dc8f2a66ae2.png";


//////////////////
// WEBPACK FOOTER
// ../images/publisher/profile/yes-active.png
// module id = 1059
// module chunks = 69